<template>
  <div class="bottom-button">
    <div class="bottom-button__header">
      <div class="bottom-button__header__logo" v-if="logoUrl">
        <img class="bottom-button__header__logo--src" :src="logoUrl" />
      </div>
      <div class="bottom-button__header__info">
        <div class="bottom-button__header__info--title">
          {{ title }}
        </div>
        <div class="bottom-button__header__info--official">
          <div
            class="offical-icon"
            v-if="qualificationImg"
            :style="{ backgroundImage: 'url(' + qualificationImg + ')' }"
          ></div>
          <div class="offical-text">{{ subTitle }}</div>
        </div>
      </div>
    </div>
    <div class="bottom-button__middle">
      <basic-button
        :btnImg="btnImg"
        :buttonText="buttonText"
        :width="width"
        :height="height"
        :fontSize="fontSize"
        :bankType="bankType"
        :hasOpenThatBank="hasOpenThatBank"
        :pushSubWalletABStrategy="pushSubWalletABStrategy"
        @download="download"
      />
    </div>
    <div class="bottom-button__tip">
      为保证礼包成功发放，请使用 {{ mobileMask }} 登录
    </div>
  </div>
</template>
<script>
import { lxConfig } from '@/analytic/guideConfig';
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import '../../components/BasicButton.vue';
import BasicButton from '../../components/BasicButton.vue';
export default {
  components: {
    BasicButton
  },
  props: {
    mobileMask: {
      type: String,
      default: ''
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    couponPackage: {
      type: Object,
      default: () => {}
    },
    bankName: {
      type: String,
      default: ''
    },
    applyPageType: {
      type: String,
      default: ''
    },
    pageABStrategy: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
    bankType: {
      type: String, 
      default: ''
    }
  },
  data() {
    return {
      width: '5.82rem',
      height: '1.06rem',
      fontSize: '0.34rem',
      btnImg:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/guide-bottom-btn-20220726.png'
    };
  },
  created() {
    lx.mv(
      lxConfig.mv_bottom_download,
      {
        from: env.from,
        abtest: this.pageABStrategy,
        page_type: this.applyPageType,
        user_status: this.userStatus || -999
      },
      {
        cid: lxConfig.pv
      }
    );
  },
  computed: {
    logoUrl() {
      if (this.hasOpenThatBank) {
        return 'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/dcep-meiuan-logo-20220407.png';
      }
      return 'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/dcep-logo-20220408.png';
    },
    qualificationImg() {
      if (this.hasOpenThatBank) {
        return '';
      }
      return 'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/qualification-img-20220408.png';
    },
    title() {
      if (this.hasOpenThatBank) {
        return `选择美团开通钱包快付，立得${this.couponPackage &&
          this.couponPackage.coupon}元券包`;
      }
      return `下载/打开数字人民币APP，领${this.couponPackage.coupon +
        this.couponPackage.redEnvelop}元礼包`;
    },
    subTitle() {
      if (this.hasOpenThatBank) {
        return '';
      }
      return '中国人⺠银行官方发行App';
    },
    buttonText() {
      if (this.hasOpenThatBank) {
        return '去数字人民币App领取';
      }
      return '下载/打开App领礼包';
    },
    userStatus() {
      if (this.currentBankHasBinding) {
        return '已推子';
      }
      if (this.hasOpenThatBank) {
        return '开通未推子';
      }
      if (!this.hasOpenThatBank) {
        return '报名未开通';
      }
    }
  },
  methods: {
    download() {
      lx.mc(
        lxConfig.mc_bottom_download,
        {
          from: env.from,
          abtest: this.pageABStrategy,
          page_type: this.applyPageType,
          user_status: this.userStatus || -999
        },
        {
          cid: lxConfig.pv
        }
      );
    }
  }
};
</script>
<style scoped lang="less">
.bottom-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
  padding: 0.4rem 0;
  margin: 0 auto;
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    &__logo {
      width: auto;
      height: 0.68rem;
      &--src {
        width: auto;
        height: 100%;
      }
    }
    &__info {
      margin-left: 0.15rem;
      &--title {
        font-family: PingFangSC-Semibold;
        font-size: 0.28rem;
        color: #222222;
        letter-spacing: 0;
        font-weight: 600;
        line-height: 0.4rem;
      }
      &--official {
        display: flex;
        align-items: center;
        .offical-icon {
          width: 0.25rem;
          height: 0.25rem;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .offical-text {
          opacity: 0.4;
          font-family: PingFangSC-Regular;
          font-size: 0.2rem;
          color: #000000;
          letter-spacing: 0;
          line-height: 0.32rem;
          font-weight: 400;
        }
      }
    }
  }
  &__middle {
    margin: 0.36rem auto 0.25rem;
  }
  &__tip {
    font-family: PingFangSC-Regular;
    font-size: 0.22rem;
    color: #000000;
    opacity: 0.4;
    text-align: center;
    font-weight: 400;
    line-height: 0.3rem;
  }
}
</style>
